export default "__VITE_ASSET__Ds2tgZO3__"